const { request } = require("../../rest/index");
const appendQueryParams = require("../../utils/append-query-params");

const { getSessionHeaders } = require("./helpers/session-headers");

let baseUrl = "";
const setBaseUrl = (value) => {
  baseUrl = value;
};

const jsonHeaders = (cookies = {}) => ({
  ...getSessionHeaders(cookies),
  "content-type": "application/json",
});

const getCheckoutData = (cookies) => {
  return request.get(`${baseUrl}/website/v2/checkout/user`, null, {
    headers: jsonHeaders(cookies),
  });
};

const getKlarnaToken = (paymentMethodId, cookies) => {
  const url = appendQueryParams(
    {
      klarna_payment_method_id: paymentMethodId,
    },
    `${baseUrl}/api/klarna/sessions`
  );

  return request.post(url, null, { headers: jsonHeaders(cookies) });
};

const authorizeKlarnaPayment = (authorizationToken, cookies) => {
  const url = appendQueryParams(
    {
      authorization_token: authorizationToken,
      currency_code: cookies.currency,
    },
    `${baseUrl}/checkout/klarna/payments`
  );

  return request.post(url, null, { headers: jsonHeaders(cookies) });
};

const getCheckoutState = async (cookies, extraHeaders = {}) => {
  const response = await request.get(
    `${baseUrl}/website/v2/checkout/state`,
    null,
    { headers: { ...jsonHeaders(cookies), ...extraHeaders }, redirect: "error" }
  );
  return response.body.state;
};

const submitUserDetails = (payload, cookies) => {
  return request.post(
    `${baseUrl}/website/v2/checkout/shipping`,
    JSON.stringify(payload),
    { headers: jsonHeaders(cookies) }
  );
};

const getShippingMethods = (cookies) => {
  return request.get(`${baseUrl}/website/v2/checkout/shipping/methods`, null, {
    headers: jsonHeaders(cookies),
  });
};

const submitShippingMethods = (payload, cookies) => {
  return request.post(
    `${baseUrl}/website/v2/checkout/shipping/methods`,
    JSON.stringify(payload),
    { headers: jsonHeaders(cookies) }
  );
};

const getPaymentMethods = (cookies, extraHeaders = {}) =>
  request.get(`${baseUrl}/website/v2/checkout/payment/methods`, null, {
    headers: { ...jsonHeaders(cookies), ...extraHeaders },
    redirect: "error",
  });

const submitPaidForPayment = (cookies) => {
  return request
    .post(`${baseUrl}/website/v2/checkout/payment/free`, null, {
      headers: jsonHeaders(cookies),
    })
    .then((res) => res.body);
};

const getPaymentMethodSession = (paymentMethod, cookies, body = null) => {
  return request
    .post(`${baseUrl}/website/v2/checkout/payment/${paymentMethod}`, body, {
      headers: jsonHeaders(cookies),
    })
    .then((res) => res.body);
};

const pay = (paymentMethod, cookies, body = null) => {
  return request
    .post(`${baseUrl}/website/v2/checkout/payment/${paymentMethod}/pay`, body, {
      headers: jsonHeaders(cookies),
    })
    .then((res) => res.body);
};

const submitPaypalOrder = (payload, cookies) => {
  return request.post(
    `${baseUrl}/website/v2/checkout/payment/paypal_checkout/order_approved`,
    JSON.stringify(payload),
    { headers: jsonHeaders(cookies) }
  );
};

const payPaypalOrder = (cookies) => {
  return request
    .post(
      `${baseUrl}/website/v2/checkout/payment/paypal_checkout/pay_approved_order`,
      {},
      { headers: jsonHeaders(cookies) }
    )
    .then((res) => res.body);
};

module.exports = {
  getCheckoutData,
  getCheckoutState,
  submitUserDetails,
  setBaseUrl,
  getShippingMethods,
  submitPaidForPayment,
  submitShippingMethods,
  getPaymentMethods,
  getPaymentMethodSession,
  pay,
  getKlarnaToken,
  authorizeKlarnaPayment,
  submitPaypalOrder,
  payPaypalOrder,
};
